import React, { Component } from "react";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/interview-dojo/id6755057417";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.rabin.interviewdojo&pcampaignid=web_share";

const APP_STORE_BADGE =
  "https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg";
const PLAY_STORE_BADGE =
  "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";

/* --- QR code images (no deps) --- */
const QR_SIZE = 220; // px
const makeQr = (url, size = QR_SIZE) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(
    url
  )}`;
const PLAY_QR = makeQr(PLAY_STORE_URL);
const PLAY_QR_2X = makeQr(PLAY_STORE_URL, QR_SIZE * 2);
const APP_QR = makeQr(APP_STORE_URL);
const APP_QR_2X = makeQr(APP_STORE_URL, QR_SIZE * 2);

/* --- Small badge helpers --- */
const badgeBoxStyle = {
  width: 160,
  height: 48,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const badgeImgStyle = {
  maxWidth: "100%",
  maxHeight: "100%",
  display: "block",
};

class InterviewGuidePrivacyPolicy extends Component {
  render() {
    return (
      <div className="text-left m-5">
        {/* Local styles just for the QR panel */}
        <style>{`
          .qr-panel {
            background: #f8fbff;
            border: 1px solid #e6efff;
            border-radius: 14px;
          }
          .qr-img {
            border-radius: 10px;
            background: #fff;
            padding: 8px;
            border: 1px solid #e5e7eb;
            box-shadow: 0 2px 10px rgba(16,24,40,.06);
          }
        `}</style>

        <h2 className="mb-3">Interview Dojo — Mobile App (iOS &amp; Android)</h2>

        {/* NEW: QR codes panel (like your mock) */}
        <section className="qr-panel p-4 p-md-5 mb-4 text-center">
          <h3 className="h4 text-primary mb-4">Need the App?</h3>

          <div className="row g-4 justify-content-center">
            {/* Google Play QR */}
            <div className="col-12 col-md-5 d-flex flex-column align-items-center">
              <img
                className="qr-img mb-3"
                src={PLAY_QR}
                srcSet={`${PLAY_QR_2X} 2x`}
                alt="QR code to open Google Play: Interview Dojo"
                width={QR_SIZE}
                height={QR_SIZE}
              />
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get Interview Dojo on Google Play"
              >
                <div style={badgeBoxStyle}>
                  <img
                    src={PLAY_STORE_BADGE}
                    alt="Get it on Google Play"
                    style={badgeImgStyle}
                    loading="lazy"
                  />
                </div>
              </a>
            </div>

            {/* App Store QR */}
            <div className="col-12 col-md-5 d-flex flex-column align-items-center">
              <img
                className="qr-img mb-3"
                src={APP_QR}
                srcSet={`${APP_QR_2X} 2x`}
                alt="QR code to open Apple App Store: Interview Dojo"
                width={QR_SIZE}
                height={QR_SIZE}
              />
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download Interview Dojo on the App Store"
              >
                <div style={badgeBoxStyle}>
                  <img
                    src={APP_STORE_BADGE}
                    alt="Download on the App Store"
                    style={badgeImgStyle}
                    loading="lazy"
                  />
                </div>
              </a>
            </div>
          </div>

          <div className="mt-3 h5 text-primary mb-0">Scan code to download</div>
        </section>

        {/* Product-only description (no privacy policy) */}
        <p className="lead">
          Interview Dojo is a focused prep app to help you quickly level up for
          coding, system design, and behavioral interviews—on the go.
        </p>

        <h3 className="h5 mt-4">What you get</h3>
        <ul>
          <li>
            <strong>Curated Q&amp;A libraries</strong> across Java, Python,
            React JS, Angular, SQL, Kafka, AWS, Azure, and more.
          </li>
          <li>
            <strong>Bookmark Features</strong> to save it and review later.
          </li>
          <li>
            <strong>Flash Cards</strong> to test your knowledge on the fly.
          </li>
          <li>
            <strong>Daily Notification on one Tech topic</strong> users can
            configure the timing.
          </li>
          <li>
            <strong>System Design playbook</strong> with checklists and
            trade-offs to structure your answers.
          </li>
          <li>
            <strong>Behavioral (STAR) prompts</strong> to craft concise,
            high-impact stories.
          </li>
          <li>
            <strong>Proficiency Tests on various tech stacks</strong> with an
            option to get certified which you can post on LinkedIn.
          </li>
          <li>
            <strong>Dark mode &amp; offline reading</strong> for late-night or
            low-signal prep.
          </li>
        </ul>

        <h3 className="h5 mt-4">Who it’s for</h3>
        <p>
          Busy engineers, new grads, and career switchers who want a crisp,
          no-noise interview companion on iOS and Android.
        </p>

        <h3 className="h5 mt-4">Try it &amp; tell us what you think</h3>
        <p className="mb-0">
          Download the app above or scan a code, practice a few sets, and{" "}
          <strong>share your feedback or leave a review</strong>. Your input
          helps us prioritize new topics and improvements.
        </p>
      </div>
    );
  }
}

export default InterviewGuidePrivacyPolicy;
